import * as React from "react";
import type {ViewSharingSettingsData, Permission, XyiconFeature} from "../../../generated/api/base";
import type {User} from "../../../data/models/User";
import type {UserGroup} from "../../../data/models/UserGroup";
import {PopupV5} from "../popup/PopupV5";
import type {ReportSharingSettingsData} from "../../../generated/api/reports";
import SharingContentCommon from "./SharingContentCommon";

export interface IGlobalViewFolderSharingSettingsData {
	userID?: string | null;
	userGroupID?: string | null;
}

interface IEditViewSharingProps {
	readonly onAddClick: (id: string, permission: Permission.View | Permission.Update, feature: XyiconFeature) => void;
	readonly onDeleteUserGroup: (userGroup: UserGroup) => Promise<any>;
	readonly onDeleteUser: (user: User) => Promise<any>;
	readonly onConfirmOwnershipChange: (sharing: ViewSharingSettingsData | ReportSharingSettingsData | IGlobalViewFolderSharingSettingsData) => void;
	readonly onSaveChanges: () => Promise<any>;
	readonly sharingSettings: ViewSharingSettingsData[] | ReportSharingSettingsData[] | IGlobalViewFolderSharingSettingsData[];
	readonly ownedByUserId: string;
	readonly itemLabel: "View" | "Report" | "View Folder" | "Global View" | "Global Report";
	readonly itemName: string;
	readonly showShareOption: boolean;
	readonly onClose: () => void;
	readonly isGlobal?: boolean;
	readonly hiddenUserGroupIds?: string[];
}

export const SharingPopupV5 = (props: IEditViewSharingProps) => {
	const {
		onAddClick,
		onDeleteUserGroup,
		onDeleteUser,
		onConfirmOwnershipChange,
		onSaveChanges,
		sharingSettings,
		ownedByUserId,
		itemLabel,
		itemName,
		showShareOption,
		onClose,
		isGlobal,
		hiddenUserGroupIds = [],
	} = props;

	const handleClick = (event: React.MouseEvent) => {
		event?.stopPropagation();
	};

	return (
		<PopupV5
			onClose={onClose}
			label={`Share ${itemLabel}: ${itemName}`}
			centerOnScreen={true}
			className="SharingPopup"
			width="528px"
			height="528px"
			freezeRoot={true}
			closeOnClickOutside={false}
			onClick={handleClick}
		>
			<SharingContentCommon
				onAddClick={onAddClick}
				onDeleteUserGroup={onDeleteUserGroup}
				onDeleteUser={onDeleteUser}
				onConfirmOwnershipChange={onConfirmOwnershipChange}
				onSaveChanges={onSaveChanges}
				ownedByUserId={ownedByUserId}
				itemLabel={itemLabel}
				itemName={itemName}
				sharingSettings={sharingSettings}
				showShareOption={showShareOption}
				isGlobal={isGlobal}
				hiddenUserGroupIds={hiddenUserGroupIds}
			/>
		</PopupV5>
	);
};
